<template>
	<!-- technitians list -->
	<ui-list :data="commissions">
		<div v-for="commission in commissions" :key="commission.id">
			<el-col :span="24"
				><div class="grid-content bg-purple-dark">
					<span>{{ commission.technician.name }}</span>
				</div></el-col
			>
			<ClosedRepairsTableReact :repairs="commission.repairs" />
			<span> Total ............</span>
			<span>{{ commission.total }}</span>
		</div>
	</ui-list>
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClosedRepairsTable } from "@/components/technician/ClosedRepairsTable";

const ClosedRepairsTableReact = ReactInVue(ClosedRepairsTable);

export default {
	components: {
		ClosedRepairsTableReact,
	},
	data() {
		return {
			total: 0,
			commissions: [],
		};
	},

	created() {
		this.$stellar.action("getCommissionAllTechnicians").then((response) => {
			this.commissions = response.commissions;
		});
	},
	methods: {},
};
</script>
